var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.7315 4.98779L7.47146 7.97613C7.08646 8.32904 6.45646 8.32904 6.07146 7.97613L2.81146 4.98779","stroke":"#0A9E50","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowDownInline.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
